/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontype from './actionTypes';

const initialstate = { plan_type: '', first_load: false, rebate_pgm: 'MDFD' };

const reducer = (state = initialstate, action) => {
  switch (action.type) {
    case actiontype.PLAN_TYPE:
      return { ...state, plan_type: action.payload };
    case actiontype.FIRST_LOAD_REB:
      return { ...state, first_load: action.payload };
    case actiontype.PLAN_TYPE_LIST:
      return { ...state, plan_list: action.payload };
    case actiontype.CLEAR_SEARCH_REDUX:
      return initialstate;
    case actiontype.REBATE_PGM_LIST:
      return { ...state, rebate_pgm_list: action.payload };
    case actiontype.REBATE_PGM:
      return { ...state, rebate_pgm: action.payload };
    case actiontype.ERROR_MSG:
      return { ...state, error_arr: action.payload };
    case actiontype.PGM_DETAIL:
      return { ...state, pgm_res: action.payload };
    default:
      return state;
  }
};

export default reducer;
